import {useGraphMeta} from "@hantera/portal-app";

type GraphMeta = ReturnType<typeof useGraphMeta>;
type GraphNodeMeta = GraphMeta[string];
type GraphFieldMeta = GraphNodeMeta['fields'][string];

/**
 * Extracts available fields from graph meta, filtering out dynamic fields.
 * Handles nested single-cardinality edges (like invoiceRecipient, deliveryAddress).
 */
export function getAvailableFields(
  graphMeta: GraphMeta,
  nodeName: string,
  prefix = ''
): string[] {
  const nodeMeta = graphMeta[nodeName];
  if (!nodeMeta) return [];

  const fields: string[] = [];

  for (const [fieldName, fieldMeta] of Object.entries(nodeMeta.fields)) {
    if (isDynamicField(fieldMeta)) continue;

    const fullFieldName = prefix ? `${prefix}.${fieldName}` : fieldName;
    fields.push(fullFieldName);
  }

  return fields.sort();
}

function isDynamicField(fieldMeta: GraphFieldMeta): boolean {
  return fieldMeta.valueType.type === 'dynamicFields';
}

export default function useGraphAvailableFields() {
  const graphMeta = useGraphMeta();

  return {
    getAvailableFields: (nodeName: string, prefix = '') => 
      getAvailableFields(graphMeta, nodeName, prefix)
  };
}
